/**
 * Creates a tag that contains the name of the current integration
 */
export default class ItemHeaderTag {
	/**
	 * Saves the parameters as properties, create the Node of the tag, and returns it
	 *
	 * @param {Object} options                       The options
	 * @param {String} options.integrationId         The integration ID
	 * @param {String} options.customIntegrationName The name of the integration. Useful if the integration name is not defined
	 * @return {Node}                                 The tag's Node
	 */
	constructor( { integrationId, customIntegrationName } ) {
		// Save the integration ID
		this.integrationId = integrationId;

		// Save the custom integration name. This will most likely be undefined. It's ok
		this.customIntegrationName = customIntegrationName;

		// Create the node
		this.createItemTag();

		// Return the tag
		return this.$tag;
	}

	/**
	 * Creates the tag with the name of the integration
	 *
	 * @return {undefined}
	 */
	createItemTag() {
		// Get integration by integrationId
		const integration = UncannyAutomator.integrations[ this.integrationId ];

		// Create container
		const $tag = document.createElement( 'div' );
		$tag.classList.add( 'uap-item-tag' );

		// Add content
		$tag.innerText = _uo.utility.isDefined( integration ) ? integration.name : this.customIntegrationName;

		// Save tag
		this.$tag = $tag;
	}
}
